import { LeadCurd } from "./leadCrud";

export default function RejectLeads() {
  return <LeadCurd name="翻新客户" type="reject" router="reject" />;
}
